$(function () {
  const body = $('#body');

  const contactMenu = $('#contact-menu').closest('#menu-container');
  const contactMenuCloseBtn = contactMenu.find('#menu-close-btn');
  const contactButton = $('.contact-menu-btn');

  const mainMenu = $('#main-menu').closest('#menu-container');
  const mainMenuCloseBtn = mainMenu.find('#menu-close-btn');
  const mainMenuButton = $('.hamburger-menu-btn');

  contactButton.each(function (idx, element) {
    $(element).click(() => {
      mainMenu.removeClass('v2-animate-fadeInFast');
      mainMenu.addClass('v2-pointer-events-none v2-opacity-0');

      contactMenu.removeClass(
        'v2-animate-fadeOutFast v2-pointer-events-none v2-opacity-0'
      );
      contactMenu.addClass('v2-animate-fadeInFast');
      body.addClass('v2-overflow-y-hidden');
    });
  });

  contactMenuCloseBtn.click(() => {
    contactMenu.removeClass('v2-animate-fadeInFast');
    contactMenu.addClass(
      'v2-animate-fadeOutFast v2-pointer-events-none v2-opacity-0'
    );
    body.removeClass('v2-overflow-y-hidden');
  });

  mainMenuButton.each(function (idx, element) {
    $(element).click(() => {
      contactMenu.removeClass('v2-animate-fadeInFast');
      contactMenu.addClass('v2-pointer-events-none v2-opacity-0');

      mainMenu.removeClass(
        'v2-animate-fadeOutFast v2-pointer-events-none v2-opacity-0'
      );
      mainMenu.addClass('v2-animate-fadeInFast');
      body.addClass('v2-overflow-y-hidden');
    });
  });

  mainMenuCloseBtn.click(() => {
    mainMenu.removeClass('v2-animate-fadeInFast');
    mainMenu.addClass(
      'v2-animate-fadeOutFast v2-pointer-events-none v2-opacity-0'
    );
    body.removeClass('v2-overflow-y-hidden');
  });
});
